module.exports = {
  src: __webpack_public_path__ + "somethingsWrong-c5659725.png",
  width: 113,
  height: 158,
  bytes: 6357,
  type: "png",
};
module.exports.toString = function() {
  return __webpack_public_path__ + "somethingsWrong-c5659725.png";
};